module.exports = __webpack_public_path__ + "img/neutral-persona.5a4b01eb.svg";